import React from "react"
import styled from "styled-components"
import { Card, CardBody, Col, Row } from "reactstrap"
import ReactTableForm from "../../../../components/Common/ReactTableForm"
import { formatNumbersForTable } from "../../../../helpers/utils"
import PropTypes from "prop-types"
import { getCohortReportFilterData } from "../../../../helpers/jwt_helper"
import CohortReportsBreadcrumb from "./CohortReportsBreadcrumb"

const paths = [
  { from: "media_source", to: "campaign" },
  { from: "campaign", to: "ad" }
]

const CohortReportsTableView = ({ data, loading, title, sub_title, cohort_setup, options, onChange }) => {

  const [tableData, setTableData] = React.useState(data)
  const [search, setSearch] = React.useState('')
  const [columns, setColumns] = React.useState([
    {
      Header: "Media Source",
      // accessor: "media_source",
      nowrap: true,
      accessor: row => (
        <>
          {row.media_source}
          {/*<Link*/}
          {/*  to={{*/}
          {/*    pathname: `/quality-non-cahort-report/${this.props.match.params.app_id}/${row.media_source}`,*/}
          {/*    state: {*/}
          {/*      app_name: this.state.app_name,*/}
          {/*    },*/}
          {/*  }}*/}
          {/*>*/}
          {/*  {row.media_source}*/}
          {/*</Link>*/}
        </>
      ),
      isSorted: true
    },
    {
      Header: "Users",
      accessor: row => formatNumbersForTable(row.users),
      isSorted: true,
      nowrap: true
    },
    {
      Header: "Spend",
      accessor: row => formatNumbersForTable(row.spend),
      isSorted: true,
      nowrap: true
    }
  ])

  React.useEffect(() => {
    if (!cohort_setup.group_by[0]) return void 0

    const onClick = async (row, i) => {
      // console.log({ row, i })

      const path = paths.find(el => el.from === i.value)

      if (!path) return void 0

      try {
        let sub_options = await getCohortReportFilterData({
          field: i.value, // i.value === media_source
          app_id: cohort_setup.app_id
        })
        sub_options = sub_options.map(el => ({ value: el, label: el }))

        switch (i.value) {
          case "media_source":
            onChange({
              filter_by: [{
                value: options.group_by.find(el => el.value === "media_source"),
                sub_value: [sub_options.find(el => el.value === row[i.value])],
                sub_options
              }],
              group_by: [options.group_by.find(el => el.value === "campaign")]
            })
            break
          case "campaign":
            const f_mediaSource = cohort_setup.filter_by.find(i => (i.value.value === "media_source" && i.sub_value?.length === 1))
            if (!f_mediaSource) return void 0
            onChange({
              filter_by: [{
                value: options.group_by.find(el => el.value === "campaign"),
                sub_value: [sub_options.find(el => el.value === row[i.value])],
                sub_options
              }, f_mediaSource],
              group_by: [options.group_by.find(el => el.value === "ad")]
            })
            break
          default:
            break
        }

      } catch (e) {
        console.error(e)
      }
    }

    const hasPath = name => paths.some(i => i.from === name)

    const cols = cohort_setup.group_by.map((i, idx) => ({
      Header: i.label,
      accessor: row => <span onClick={() => onClick(row, i)}
                             style={{ color: hasPath(i.value) ? "#556ee6" : "inherit" }}>{row[i.value]}</span>,
      isSorted: true,
      style: {
        minWidth: i.label === 'Date' && '95px',
      },
      nowrap: true
      // isSticky: idx === 0,
    }))
    cols.push({
      Header: "Users",
      accessor: row => formatNumbersForTable(row.users),
      isSorted: true,
      nowrap: true
      // isSticky: true
    })

    cols.push({
      Header: "Spend",
      accessor: row => <span className="text-nowrap">{formatNumbersForTable(row.spend)}</span>,
      isSorted: true,
      nowrap: true
      // isSticky: true
    })

    const col_by_day = (new Array(cohort_setup.days.value).fill(0)).map((_, idx) => ({
      Header: `Day ${idx}`,
      accessor: row => <span
        className="text-nowrap">{!!+row.days[idx] ? row.days[idx] : formatNumbersForTable(row.days[idx])}</span>,
      nowrap: true
    }))
    setColumns([...cols, ...col_by_day])
  }, [cohort_setup, options, onChange])


  React.useEffect(() => {
    setTableData(
      data.filter(row => {
        for (let key in row) {
          const item = row[key]
          try {
            if (item.toString().toLowerCase().includes(search.toLowerCase())) {
              return true
            }
          } catch (e) {}
        }
        return false
      })
    )
  }, [search, data])

  const onTableChange = (obj) => {
    setSearch(obj.search)
  }

  return (
    <CohortReportsTableViewStyled>
      <CardBody>
        <h4>{title}</h4>
        <p>User performance {sub_title && `(${sub_title})`} over days post-install</p>
        <CohortReportsBreadcrumb
          cohort_setup={cohort_setup}
          onClick={onChange}
        />
        <ReactTableForm
          loading={loading}
          columns={columns}
          data={{ results: tableData }}
          isSearch
          onTableChange={onTableChange}
        />
      </CardBody>
    </CohortReportsTableViewStyled>
  )
}

CohortReportsTableView.propTypes = {
  data: PropTypes.any,
  loading: PropTypes.bool,
  title: PropTypes.string,
  sub_title: PropTypes.string,
  cohort_setup: PropTypes.any,
  options: PropTypes.any,
  onChange: PropTypes.func
}

const CohortReportsTableViewStyled = styled(Card)`
`

export default (CohortReportsTableView)
